(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lauro-service-video"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!window.customElements || customElements.get('lauro-service-video')) return;
  customElements.define('lauro-service-video', class extends HTMLElement {
    connectedCallback() {
      if (this.active) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.active = true;
      this.visible = false;
      this.userPaused = false;
      this.optedIn = false;
      this.pending = false;
      this.playToken = (this.playToken || 0) + 1;
      this.motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      this.connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      this.video.muted = true;
      this.onClick = () => {
        if (!this.video.paused || this.pending) {
          this.userPaused = true;
        } else {
          this.optedIn = true;
          this.userPaused = false;
          this.visible = true;
        }
        this.sync();
      };
      this.onPolicy = () => {
        if (!this.optedIn && this.restricted()) this.unload();
        this.sync();
      };
      this.onPlaying = () => {
        if (!this.wanted()) return this.video.pause();
        this.classList.add('has-frame');
        this.updateControl();
      };
      this.onPause = () => this.updateControl();
      this.onError = () => {
        this.userPaused = true;
        this.classList.remove('has-frame');
        this.sync();
      };
      this.onGeometry = () => {
        const rect = this.getBoundingClientRect();
        this.visible = rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
        this.sync();
      };
      this.button.addEventListener('click', this.onClick);
      this.video.addEventListener('playing', this.onPlaying);
      this.video.addEventListener('pause', this.onPause);
      this.video.addEventListener('error', this.onError);
      document.addEventListener('visibilitychange', this.onPolicy);
      if (this.motion?.addEventListener) this.motion.addEventListener('change', this.onPolicy);
      else this.motion?.addListener?.(this.onPolicy);
      this.connection?.addEventListener?.('change', this.onPolicy);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
          this.sync();
        }, { threshold: [0, 0.2] });
        this.observer.observe(this);
      } else {
        window.addEventListener('scroll', this.onGeometry, { passive: true });
        window.addEventListener('resize', this.onGeometry);
        this.onGeometry();
      }
      this.button.hidden = false;
      this.updateControl();
    }
    restricted() {
      const connection = this.connection;
      return Boolean(this.motion?.matches || connection?.saveData || ['slow-2g', '2g'].includes(connection?.effectiveType) || (typeof connection?.downlink === 'number' && connection.downlink < 1.5));
    }
    wanted() {
      return this.active && this.isConnected && this.visible && !document.hidden && !this.userPaused && (this.optedIn || (this.observer && !this.restricted()));
    }
    sync() {
      if (!this.wanted()) {
        this.playToken++;
        this.pending = false;
        this.video.pause();
        this.updateControl();
        return;
      }
      if (this.pending || !this.video.paused) return;
      if (!this.video.hasAttribute('src')) {
        this.video.src = this.dataset.video;
        this.video.load();
      }
      this.pending = true;
      const token = ++this.playToken;
      Promise.resolve(this.video.play()).then(() => {
        if (token === this.playToken && !this.wanted()) this.video.pause();
      }).catch(() => {
        if (token === this.playToken && this.active && this.wanted()) {
          this.userPaused = true;
          this.classList.remove('has-frame');
        }
      }).finally(() => {
        if (token !== this.playToken) return;
        this.pending = false;
        if (this.active) this.updateControl();
      });
    }
    updateControl() {
      const playing = !this.video.paused;
      this.button.textContent = playing ? 'Pausa video' : 'Riproduci video';
      this.button.setAttribute('aria-label', (playing ? 'Metti in pausa' : 'Riproduci') + ' il video: ' + this.dataset.label);
    }
    unload() {
      this.playToken++;
      this.pending = false;
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      this.classList.remove('has-frame');
    }
    disconnectedCallback() {
      if (!this.active) return;
      this.active = false;
      this.observer?.disconnect();
      this.observer = null;
      this.button.removeEventListener('click', this.onClick);
      this.video.removeEventListener('playing', this.onPlaying);
      this.video.removeEventListener('pause', this.onPause);
      this.video.removeEventListener('error', this.onError);
      document.removeEventListener('visibilitychange', this.onPolicy);
      if (this.motion?.removeEventListener) this.motion.removeEventListener('change', this.onPolicy);
      else this.motion?.removeListener?.(this.onPolicy);
      this.connection?.removeEventListener?.('change', this.onPolicy);
      window.removeEventListener('scroll', this.onGeometry);
      window.removeEventListener('resize', this.onGeometry);
      this.unload();
      this.button.hidden = true;
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wg-contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__lauroContactTrackingV1) return;
  window.__lauroContactTrackingV1 = true;

  const storageKey = 'lauro:contact:attempt:v1';
  const eventName = 'lauro:contact_request_succeeded';
  const maxAge = 30 * 60 * 1000;
  const maxRetries = 20;

  function start() {
    const marker = document.querySelector('[data-lauro-contact-tracking]');
    if (!marker) return;
    const formId = marker.dataset.formId;
    const form = marker.closest('form');
    const path = marker.dataset.pagePath;
    if (!form || form.id !== formId || path !== '/pages/contact' || location.pathname !== path) return;

    let retries = 0;
    let retryTimer = null;
    let publishing = false;

    function removeAttempt() {
      try { sessionStorage.removeItem(storageKey); } catch {}
    }

    function readAttempt() {
      try {
        const value = JSON.parse(sessionStorage.getItem(storageKey));
        if (!value || value.version !== 1 || value.form_id !== formId || value.path !== path) return null;
        if (typeof value.attempt_id !== 'string' || !/^[a-f0-9-]{36}$/i.test(value.attempt_id)) return null;
        if (!Number.isFinite(value.created_at) || Date.now() < value.created_at || Date.now() - value.created_at > maxAge) {
          removeAttempt();
          return null;
        }
        return value;
      } catch {
        return null;
      }
    }

    function writeAttempt(value) {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(value));
        return true;
      } catch {
        return false;
      }
    }

    function liveEnvironment() {
      return marker.dataset.designMode !== 'true'
        && marker.dataset.visualPreviewMode !== 'true'
        && !window.Shopify?.designMode
        && window.Shopify?.theme?.role === 'main'
        && !new URLSearchParams(location.search).has('preview_theme_id');
    }

    function permitted() {
      try {
        const privacy = window.Shopify?.customerPrivacy;
        return privacy?.analyticsProcessingAllowed() === true
          && privacy?.marketingAllowed() === true
          && privacy?.saleOfDataAllowed() === true;
      } catch {
        return false;
      }
    }

    function privacyAvailable() {
      const privacy = window.Shopify?.customerPrivacy;
      return typeof privacy?.analyticsProcessingAllowed === 'function'
        && typeof privacy?.marketingAllowed === 'function'
        && typeof privacy?.saleOfDataAllowed === 'function';
    }

    function cancelRetry() {
      if (retryTimer !== null) clearTimeout(retryTimer);
      retryTimer = null;
    }

    function scheduleRetry() {
      if (retryTimer !== null || retries >= maxRetries) return;
      retries += 1;
      retryTimer = setTimeout(() => {
        retryTimer = null;
        publishSuccess();
      }, 250);
    }

    function restoreAttempt(attempt) {
      publishing = false;
      if (!permitted() || !liveEnvironment()) {
        removeAttempt();
        return;
      }
      const current = readAttempt();
      if (current?.attempt_id !== attempt.attempt_id) return;
      if (writeAttempt({ ...attempt, status: 'pending' })) scheduleRetry();
    }

    function publishSuccess() {
      if (publishing || marker.dataset.formState !== 'success') return;
      if (!liveEnvironment()) {
        cancelRetry();
        removeAttempt();
        return;
      }
      if (!privacyAvailable()) return;
      if (!permitted()) {
        cancelRetry();
        removeAttempt();
        return;
      }
      const attempt = readAttempt();
      if (!attempt || attempt.status !== 'pending') return;
      if (typeof window.Shopify?.analytics?.publish !== 'function') {
        scheduleRetry();
        return;
      }
      if (!writeAttempt({ ...attempt, status: 'consumed' })) return;
      publishing = true;
      cancelRetry();
      let result;
      try {
        result = window.Shopify.analytics.publish(eventName, {
          schema_version: 1,
          attempt_id: attempt.attempt_id,
          form_id: formId,
          path,
          request_type: 'preventivo',
        });
      } catch {
        restoreAttempt(attempt);
        return;
      }
      Promise.resolve(result).then(value => {
        if (value === false) restoreAttempt(attempt);
        else publishing = false;
      }, () => restoreAttempt(attempt));
    }

    function recordAttempt(event) {
      if (event.isTrusted === false || !form.checkValidity()) return;
      const requestType = form.querySelector('[name="contact[Tipo di richiesta]"]');
      if (requestType && requestType.value !== 'Preventivo') {
        removeAttempt();
        return;
      }
      removeAttempt();
      if (!liveEnvironment() || !permitted() || typeof window.crypto?.randomUUID !== 'function') return;
      try {
        writeAttempt({
          version: 1,
          attempt_id: window.crypto.randomUUID(),
          form_id: formId,
          path,
          created_at: Date.now(),
          status: 'pending',
        });
      } catch {}
    }

    if (!liveEnvironment()) {
      removeAttempt();
      return;
    }
    if (marker.dataset.formState !== 'success') removeAttempt();
    if (marker.dataset.formState !== 'success') form.addEventListener('submit', recordAttempt);

    document.addEventListener('visitorConsentCollected', () => {
      if (!permitted()) {
        cancelRetry();
        removeAttempt();
      } else publishSuccess();
    });
    window.addEventListener('pagehide', cancelRetry);
    window.addEventListener('pageshow', event => {
      if (event.persisted && marker.dataset.formState !== 'success') removeAttempt();
      publishSuccess();
    });

    if (privacyAvailable()) publishSuccess();
    else if (typeof window.Shopify?.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (!error) publishSuccess();
        });
      } catch {}
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
